/** Returns the configured API base URL (without /api/v1 suffix). */
export function getApiUrl(): string {
  return import.meta.env.VITE_API_URL || "";
}
